var _style, _circle, _defs, _g, _defs2, _path, _path2, _path3, _path4, _polygon, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetInventry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{clip-path:url(#SVGID_00000169545896592230182840000002544437286849852083_);}\r\n\t.st2{fill:#0069BF;}\r\n\t.st3{fill:none;stroke:#0081EA;}\r\n\t.st4{clip-path:url(#SVGID_00000088103349687410729530000001171938543949404809_);}\r\n\t.st5{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st6{fill:#FFFFFF;stroke:#0069BF;stroke-width:0.2;stroke-miterlimit:10;}\r\n\t.st7{opacity:0.3;fill:#FFFFFF;}\r\n\t.st8{fill:#FFFFFF;stroke:#0069BF;stroke-width:0.3;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: -2.21,
    cy: 51.32,
    r: 11.55
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -0.71,
    y: -0.71,
    width: 25.41,
    height: 25.41
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000069380423293388525270000006988990452390288271_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Create_User",
    style: {
      clipPath: "url(#SVGID_00000069380423293388525270000006988990452390288271_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_255",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 11,
    cy: 11,
    r: 11.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 11,
    cy: 11,
    r: 11.12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15659",
    transform: "translate(7.981 7.25)"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000062877794018168052280000006608754141405134980_",
    x: 30.87,
    y: -2.63,
    width: 8.51,
    height: 10.06
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000180368538409714899270000002793594061327091618_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062877794018168052280000006608754141405134980_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15605",
    style: {
      clipPath: "url(#SVGID_00000180368538409714899270000002793594061327091618_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32501",
    className: "st0",
    d: "M32.12,7.43c-0.15-0.04-0.3-0.09-0.44-0.14c-0.52-0.25-0.84-0.79-0.81-1.36 c0.02-0.59,0.15-1.18,0.4-1.72c0.43-0.93,1.19-1.68,2.14-2.09l0.19-0.08c-0.81-0.59-1.2-1.6-1-2.59 c0.11-0.6,0.43-1.14,0.92-1.51c1.04-0.84,2.54-0.74,3.46,0.22c0.53,0.53,0.79,1.26,0.72,2.01c-0.06,0.74-0.44,1.43-1.04,1.86 c0.13,0.06,0.25,0.11,0.37,0.17c1.02,0.5,1.79,1.4,2.15,2.48c0.16,0.46,0.23,0.95,0.21,1.44c-0.05,0.66-0.54,1.19-1.19,1.29 c-0.02,0-0.04,0.01-0.05,0.02L32.12,7.43z M35.12,6.66c0.93,0,1.85,0,2.78,0c0.36,0.03,0.67-0.24,0.69-0.6 c0-0.04,0-0.08,0-0.12c0-0.15-0.02-0.31-0.04-0.46c-0.09-0.64-0.37-1.24-0.79-1.72c-0.54-0.65-1.31-1.07-2.15-1.19 c-0.65-0.1-1.32-0.01-1.92,0.27c-0.69,0.3-1.26,0.82-1.62,1.48c-0.29,0.52-0.44,1.11-0.44,1.71c0,0.14,0.05,0.27,0.14,0.38 c0.14,0.17,0.35,0.26,0.57,0.25L35.12,6.66 M35.12-1.86c-0.99,0.01-1.8,0.82-1.79,1.81c0.01,0.99,0.82,1.8,1.81,1.79 c0.99-0.01,1.79-0.81,1.79-1.8C36.93-1.05,36.12-1.86,35.12-1.86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32502",
    className: "st5",
    d: "M35.12,6.66h-2.77c-0.22,0.02-0.43-0.08-0.57-0.25c-0.09-0.11-0.14-0.24-0.14-0.38 c-0.01-0.6,0.14-1.19,0.44-1.72c0.36-0.66,0.93-1.18,1.62-1.48c1.41-0.63,3.07-0.25,4.07,0.92c0.42,0.49,0.7,1.09,0.79,1.72 c0.02,0.15,0.04,0.31,0.04,0.46c0.04,0.36-0.21,0.68-0.57,0.72c-0.04,0-0.08,0.01-0.13,0C36.98,6.66,36.05,6.66,35.12,6.66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32503",
    className: "st5",
    d: "M35.12-1.86c0.99,0,1.8,0.81,1.8,1.8c0,0.99-0.81,1.8-1.8,1.8c-0.99,0-1.79-0.8-1.8-1.79 C33.32-1.05,34.13-1.85,35.12-1.86"
  }))))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48.28,1.82c0,0.73,0,1.46,0,2.19c0,0.29-0.09,0.42-0.36,0.52c-1.16,0.43-2.32,0.87-3.47,1.3 c-0.16,0.06-0.31,0.06-0.46,0c-1.16-0.44-2.32-0.87-3.49-1.31c-0.26-0.1-0.36-0.23-0.36-0.51c0-1.46,0-2.93,0-4.39 c0-0.28,0.09-0.41,0.36-0.51c1.17-0.44,2.33-0.87,3.5-1.31c0.15-0.06,0.29-0.05,0.44,0c1.17,0.44,2.33,0.88,3.5,1.31 c0.25,0.09,0.35,0.24,0.35,0.5C48.28,0.35,48.28,1.08,48.28,1.82z M41.05,0.21c0,0.04-0.01,0.05-0.01,0.07c0,1.13,0,2.26,0,3.39 c0,0.08,0.04,0.11,0.1,0.14c0.57,0.21,1.14,0.43,1.72,0.64c0.29,0.11,0.59,0.22,0.89,0.33c0-1.19,0-2.37,0-3.56 C42.85,0.89,41.96,0.55,41.05,0.21z M44.66,4.78c0.05-0.02,0.09-0.03,0.12-0.04c0.82-0.31,1.64-0.61,2.46-0.92 c0.1-0.04,0.13-0.08,0.13-0.19c0-1.09,0-2.18,0-3.26c0-0.05,0-0.09,0-0.16c-0.91,0.34-1.81,0.68-2.71,1.02 C44.66,2.41,44.66,3.59,44.66,4.78z M41.89-0.45c0.05,0.02,0.08,0.04,0.1,0.05c0.71,0.27,1.42,0.54,2.14,0.8 c0.05,0.02,0.12,0.01,0.17-0.01c0.7-0.26,1.4-0.52,2.1-0.79c0.03-0.01,0.06-0.03,0.11-0.05c-0.03-0.02-0.05-0.02-0.07-0.03 c-0.72-0.27-1.43-0.54-2.15-0.81c-0.05-0.02-0.13-0.01-0.19,0.01c-0.5,0.18-1,0.37-1.51,0.56C42.37-0.63,42.15-0.54,41.89-0.45z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "44.2,-1.71 47.86,-0.41 47.86,4.07 44.27,5.35 40.63,4.1 40.63,-0.41 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M17.59,12.69c-0.03,0.21-0.05,0.43-0.09,0.64c-0.21,1.21-0.77,2.24-1.67,3.08c-0.79,0.73-1.73,1.21-2.79,1.36 c-1.93,0.28-3.58-0.29-4.91-1.72c-0.7-0.76-1.13-1.66-1.32-2.68c-0.04-0.2,0.05-0.33,0.25-0.37c0.22-0.04,0.44-0.08,0.66-0.11 c0.19-0.03,0.31,0.05,0.35,0.25c0.08,0.37,0.18,0.73,0.35,1.07c0.54,1.08,1.38,1.83,2.55,2.17c1.33,0.39,2.58,0.17,3.69-0.67 c0.87-0.65,1.39-1.52,1.58-2.59c0.37-2.06-0.89-4.1-2.87-4.66c-1.65-0.47-3.1-0.06-4.29,1.18C9.05,9.65,9.04,9.67,9.02,9.69 c0,0,0,0.01,0,0.03c0.2-0.03,0.4-0.07,0.59-0.1c0.22-0.04,0.44-0.08,0.67-0.12c0.25-0.04,0.36,0.04,0.41,0.29 c0.04,0.21,0.08,0.42,0.11,0.62c0.03,0.18-0.06,0.32-0.24,0.35c-1.07,0.19-2.13,0.38-3.2,0.57c-0.2,0.04-0.33-0.06-0.37-0.26 c-0.1-0.58-0.21-1.17-0.31-1.75C6.58,8.84,6.5,8.37,6.42,7.89C6.38,7.69,6.46,7.56,6.67,7.52C6.89,7.48,7.1,7.44,7.32,7.41 c0.2-0.03,0.33,0.06,0.36,0.28c0.08,0.43,0.15,0.86,0.23,1.31C7.95,8.96,7.98,8.93,8,8.91c0.75-0.88,1.69-1.48,2.81-1.76 c1.3-0.33,2.58-0.21,3.78,0.41c1.43,0.73,2.37,1.88,2.8,3.43c0.09,0.32,0.12,0.66,0.18,0.99c0.01,0.04,0.01,0.08,0.02,0.12 C17.59,12.28,17.59,12.48,17.59,12.69z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetInventry);
export default __webpack_public_path__ + "static/media/ResetInventry.3a789f870b3b58d1bbefd2081de17c80.svg";
export { ForwardRef as ReactComponent };